import { superAdminAccess } from "helpers/system-config";
import { checkAccessForList, makeActive } from "modules/common/utils";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { globalStateSelector } from "store/selector";
import styled from "styled-components";
import { RowTitle } from "../styles/main";
import {
  teamleaderAccess,
  userAccess,
} from "../../../../../helpers/system-config";
import { Chip } from "../../../../common/components";

const SettingDropdown = styled.div`
  background: #fff;

  border-right: 1px solid #d9d9d9;
  z-index: 1;
  &:after {
    position: relative;
    background-image: url("/images/new/slidebar-bg.png");
    z-index: -1;
    content: "";
    bottom: 0px;
    right: 0px;
    background-repeat: no-repeat;
    background-position: bottom right;
    width: 307px;
    height: 434px;
  }
  .select {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 30px;

    display: inline-flex;
    align-items: center;
    text-transform: uppercase;

    padding-left: 32px;

    color: #b1b1b1 !important;
    background: #f2f2f2;

    height: 40px;
    width: 260px;
    cursor: pointer;
    margin-bottom: 5px;
  }

  .icon {
    padding-right: 20px;
  }
  .option {
    padding-left: 32px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 50px;
    transition: all 1s;

    display: flex;
    align-items: center;
    text-transform: uppercase;

    color: #000000;
  }
  .active {
    display: flex;
    margin-left: 0px !important;
    border-left: 4px solid #28a6de;
    background: #f2f2f2;
  }
`;

function SettingDropdownMenu(props) {
  const [list, setList] = useState([]);
  const name = props.name || "Settings";

  useEffect(() => {
    setList(
      props.list
        ? getlist(
            JSON.parse(JSON.stringify(props.list)),
            props.location.pathname
          )
        : getlist()
    );
  }, [props.list, props.location.pathname, props.accessDefination]);

  function getlist(propList) {
    const {
      location = {},
      origanisation,
      currentUser,
      accessDefination,
    } = props;

    let displayProvider = false;
    if (superAdminAccess.includes(currentUser.role)) {
      displayProvider = true;
    } else {
      displayProvider =
        origanisation && origanisation.displayProvider
          ? origanisation.displayProvider
          : false;
    }
    const pathname = location.pathname || "";

    const userAndPermissions = {
      name: "Users And Permissions",
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        {
          name: "Users",
          link: "/settings/User",
          active: false,
          index: 0,
        },
        {
          name: "Skills",
          link: "/settings/Skills",
          active: false,
          index: 0,
        },
        // {
        // 	name: 'Permissions',
        // 	link: '/settings/Permissions',
        // 	active: false,
        // 	index: 0,
        // },
      ],
    };

    const communicationChannels = {
      name: "Communication Channels",
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        {
          name: `Providers`,
          link: "/settings/providers",
          active: false,
          hide: !displayProvider,
          index: 1,
        },
        {
          name: "Phone Numbers",
          link: "/settings/Phonenumbers",
          active: false,
          index: 1,
        },

        {
          name: "Integrations",
          link: "/settings/integrations",
          active: false,
          index: 1,
        },
        {
          name: "Missed Call To Campaign",
          link: "/settings/missed-call-to-campaign",
          active: false,
          index: 1,
        },
      ],
    };

    const generalSettings = {
      name: "General Settings",
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        {
          name: "Disposition",
          link: "/settings/dispose",
          active: false,
          index: 2,
        },
        {
          name: "Contacts",
          link: "/settings/Contact-List",
          active: false,
          index: 2,
        },
        {
          name: "Sounds",
          link: "/settings/sounds",
          active: false,
          index: 2,
        },
        {
          name: "Break",
          link: "/settings/Break",
          active: false,
          index: 2,
        },
        {
          name: "DNC",
          link: "/settings/DNC",
          active: false,
          index: 2,
        },
        {
          name: "Inbound Block",
          link: "/settings/inbound-block",
          active: false,
          index: 2,
        },
        {
          name: "Holiday",
          link: "/settings/Holiday-group",
          active: false,
          index: 2,
        },
        {
          name: "Flow",
          link: "/settings/flow",
          active: false,
          index: 2,
        },
        {
          name: "Knowledge Base",
          link: "/settings/knowledge-base",
          active: false,
          index: 2,
        },
        {
          name: "Import & Export",
          link: "/settings/import-export",
          active: false,
          index: 2,
        },
        {
          name: "Logs",
          link: "/settings/logs",
          active: false,
          index: 2,
        },
        {
          name: "Guardrails",
          link: "/settings/guardrails",
          active: false,
          index: 2,
        },
        {
          name: "Help Center",
          link: "/settings/help-center",
          active: false,
          index: 2,
        },
      ].filter((e) => {
        if (e.name === "Flow") {
          return userAccess.includes(currentUser.role);
        } else if (e.name === "Knowledge Base") {
          return !teamleaderAccess.includes(currentUser.role);
        } else if (e.name === "Logs") {
          return !teamleaderAccess.includes(currentUser.role);
        } else {
          return true;
        }
      }),
    };

    const accountSettings = {
      name: "Account Setting",
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        {
          name: "Account",
          link: "/settings/account-setting",
          active: false,
          index: 3,
        },
        // this.showRegion(currentUser),
        // {
        // 	name: 'Plans and Billing',
        // 	link: '#',
        // 	disabled: true,
        // 	active: false,
        // 	index: 3,
        // },
      ],
    };

    const messages = {
      name: "Messages",
      isShow: "none",
      arrow: "keyboard_double_arrow_down",
      childs: [
        {
          name: "Canned Messages",
          link: "/settings/canned-messages",
          active: false,
          index: 4,
        },
      ],
    };
    // const SecuritySettings = {
    // 	name: 'Security Setting',
    // 	isShow: 'none',
    // 	color: '#ffff',
    // 	arrow: 'keyboard_double_arrow_down',
    // 	childs: [
    // 		{
    // 			name: 'Voice Provider',
    // 			link: '/settings/voice-provider',
    // 			active: false,
    // 			index: 5,
    // 		},
    // 		{
    // 			name: 'Model Provider',
    // 			link: '/settings/model-provider',
    // 			active: false,
    // 			index: 5,
    // 		},
    // 		{
    // 			name: 'Transcriber Provider',
    // 			link: '/settings/transcriber-provider',
    // 			active: false,
    // 			index: 5,
    // 		},
    // 	],
    // };

    let list = propList || [];

    if (!propList) {
      list.push(userAndPermissions);
      if (!teamleaderAccess.includes(currentUser.role)) {
        list.push(communicationChannels);
      }
      list.push(generalSettings);
      // list.push(messages);
      if (props.currentUser.role < 5) {
        list.push(messages);
      }
      //   list.push(SecuritySettings);
      if (props.currentUser.role < 5) {
        list.push(accountSettings);
      }
    }

    list = checkAccessForList(props.accessDefination, list);

    return makeActive(list, pathname);
  }

  // function showRegion(currentUser) {
  // 	return (
  // 		superAdminAccess.includes(currentUser.role) && {
  // 			name: 'Region',
  // 			link: '/settings/region',
  // 			disabled: false,
  // 			active: false,
  // 			accessName: 'region',
  // 			index: 3,
  // 		}
  // 	);
  // }

  function openMenu(item) {
    setList((prevList) =>
      prevList.map((e) => {
        let arrow;
        let isShow;
        if (e.name === item.name) {
          isShow = e.isShow === "none" ? "block" : "none";
          arrow =
            e.arrow === "keyboard_double_arrow_down"
              ? "keyboard_double_arrow_up"
              : "keyboard_double_arrow_down";
        } else {
          isShow = "none";
          arrow = "keyboard_double_arrow_down";
        }
        return {
          ...e,
          isShow,
          arrow,
        };
      })
    );
  }

  function BetaVersion() {
    return <div className="beta-wrapper">Beta</div>;
  }

  return (
    <SettingDropdown className="for-background">
      <RowTitle
        className={`secondRow  ${
          name === "Message" ? "beta-version" : null
        } boxsmall-title`}
        style={{ margin: `${name === "Message" ? "30px 15px" : "30px"}` }}
      >
        {name}
      </RowTitle>
      <div
        style={{
          height: "calc(100vh - 162px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {list.map((e) => {
          return (
            <div
              style={e.display === false ? { display: "none" } : {}}
              key={e.name}
            >
              <div
                className={`select d-flex align-items-center justify-content-between`}
                onClick={() => {
                  openMenu(e);
                }}
              >
                {e.name}
                <span className={`material-symbols-outlined icon`}>
                  {e.arrow}
                </span>
              </div>
              <div style={{ display: e.isShow }}>
                {e.childs.map((ele) => {
                  return (
                    <Link
                      key={ele.link}
                      to={ele.link}
                      style={{
                        display: ele.hide ? "none" : "block",
                        textDecoration: "none",
                      }}
                    >
                      <div
                        className={`option ${
                          ele.active === true ? "active" : ""
                        } ${ele.disabled === true ? "mouse-block" : ""}`}
                        onClick={() => {
                          ele.active = true;
                          setList([...list]);
                        }}
                      >
                        {ele.name}
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </SettingDropdown>
  );
}

const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
  origanisation: globalStateSelector.getDynamic(state, {
    key: "origanisation",
  }),
  accessDefination: globalStateSelector.getDynamic(state, {
    key: "accessDefination",
  }),
});

export default connect(stateToProps)(withRouter(SettingDropdownMenu));



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/SettingDropdownMenu.js